import React from 'react';

import TriggerElement from './components/TriggerElement';
import GeneratorWrapper from './components/GeneratorWrapper';
import DiscardModal from './components/DiscardModal';
import './style.scss';

const CopyMagic = () => (
  <>
    <TriggerElement />
    <GeneratorWrapper />
    <DiscardModal />
  </>
);

export default CopyMagic;
